export class SkechersPoNumberHistory {

    poNumber?: string;

    constructor(
        poNumber?: string
    ) {

        this.poNumber = poNumber;
       
    }
}
